<template>
  <div class="col-lg-5 col-s-12 mt-s-3 settings" style="background-color: white;">
    <form action method="POST" id="calcForm" @submit.prevent="makeCalculation">
      <!------------------------------------ Windzone Standort ------------------------------------>
      <div class="anchor mt-1" id="windzoneAnchor"></div>
      <h4
        class="text-secondary mb-1 pt-2 pb-2"
        id="windzone"
        v-bind:class="[getActiveLink == 'windzone' ? 'activeCol' : '']"
      >Windzone & Standort</h4>
      <WindzoneStandort />

      <!------------------------------------ Gebäude ------------------------------------>
      <div class="anchor mt-4" id="gebaeudeAnchor"></div>
      <h4
        class="text-secondary mb-1 pt-2 pb-2"
        id="gebaeude"
        v-bind:class="[getActiveLink == 'gebaeude' ? 'activeCol' : '']"
      >Gebäude</h4>
      <GebaeudeCollapse />
      <!------------------------------------ Dach ------------------------------------>
      <div class="anchor mt-4" id="dachAnchor"></div>
      <h4
        class="text-secondary mb-1 pt-2 pb-2"
        id="dach"
        v-bind:class="[getActiveLink == 'dach' ? 'activeCol' : '']"
      >Dach & Pfannenmodell</h4>
      <DachPfannenmodell />

      <!------------------------------------ Berechnung ------------------------------------>
      <div class="anchor mt-3" id="berechnungAnchor"></div>
      <div class="card card-body luetfrink-collapse-card">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            v-model="nutzungshinweise"
            class="custom-control-input"
            name="inCheckNutzung"
            id="inCheckNutzung"
            required
          />
          <label class="custom-control-label" for="inCheckNutzung">
            Ich habe die
            <a
              href
              data-toggle="modal"
              data-target="#nutzungshinweisModal"
              class="support-a"
            >Nutzungshinweise</a> gelesen und bin damit einverstanden!
          </label>
        </div>
        <input
          type="submit"
          v-if="isComplete"
          v-bind:class="[getActiveLink == 'berechnung' ? 'activeBtn' : '']"
          value="Berechnen"
          id="btnBerechnung"
          name="button_berechnung"
          class="btn btn-primary mt-3"
        />
        <button v-if="!isComplete" class="btn btn-primary mt-3" @click="triggerAll()">Berechnen</button>
      </div>
    </form>
    <div
      class="alert alert-warning alert-dismissible fade show"
      role="alert"
      id="incomplete"
      style="display:none"
    >
      Überprüfen Sie bitte Ihre Eingaben! Es gibt ein oder mehr fehlerhafte Felder!
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState, mapActions } from "vuex";
import WindzoneStandort from "./collapses/WindzoneStandort";
import GebaeudeCollapse from "./collapses/Gebaeude";
import DachPfannenmodell from "./collapses/DachPfannenmodell";
import WindsogCalculator from "../calculation.js";

export default {
  name: "Configurator",
  components: {
    WindzoneStandort,
    GebaeudeCollapse,
    DachPfannenmodell
  },
  computed: {
    ...mapGetters([
      "getActiveLink",
      "getActiveTrigger",
      "getActiveContent",
      "isErlaubt",
      "isComplete"
    ]),
    ...mapState({
      windzone: state => state.inputs.windzone,
      standort: state => state.inputs.standort,
      standorthoehe: state => state.inputs.standorthoehe,
      dachform: state => state.inputs.dachform,
      gebaeudehoehe: state => state.inputs.gebaeudehoehe,
      geschlossen: state => state.inputs.geschlossen,
      deckunterlage: state => state.inputs.deckunterlage,
      dachneigung: state => state.inputs.dachneigung,
      trauflaenge: state => state.inputs.trauflaenge,
      giebellaenge: state => state.inputs.giebellaenge,
      walmtrauflaenge: state => state.inputs.walmtrauflaenge,
      walmneigung: state => state.inputs.walmneigung,
      pfannenmodell: state => state.inputs.pfannenmodell,
      lattung: state => state.inputs.lattung,
      dachpfannen: state => state.inputs.dachpfannen,
      dachpfannenObject: state => state.inputs.dachpfannenObject,
      calculationResult: state => state.inputs.calculationResult,
      nutzungshinweise: state => state.inputs.nutzungshinweise
    }),
    nutzungshinweise: {
      get() {
        return this.$store.state.inputs.nutzungshinweise;
      },
      set(value) {
        this.$store.commit("setNutzungshinweise", value);
      }
    }
  },
  mounted() {
    this.$root.$on('calculate', () => {
      this.makeCalculation();
    })
  },
  watch: {
    // Steuert das öffnen der Collapses, wenn über die Secondary Navbar navigiert wird
    getActiveTrigger() {
      var al = this.getActiveLink;

      if (al == "windzone") {
        if (
          document
            .getElementById("collapseHeadWindzone")
            .classList.contains("collapsed")
        ) {
          document.getElementById("collapseHeadWindzone").click();
        }
        if (
          document
            .getElementById("collapseHeadStandort")
            .classList.contains("collapsed")
        ) {
          document.getElementById("collapseHeadStandort").click();
        }
      }
      if (al == "gebaeude") {
        if (
          document
            .getElementById("collapseHeadGebaeude")
            .classList.contains("collapsed")
        ) {
          document.getElementById("collapseHeadGebaeude").click();
        }
      }
      if (al == "dach") {
        if (
          document
            .getElementById("collapseHeadDach")
            .classList.contains("collapsed")
        ) {
          document.getElementById("collapseHeadDach").click();
        }
        if (
          document
            .getElementById("collapseHeadPfannenmodell")
            .classList.contains("collapsed")
        ) {
          document.getElementById("collapseHeadPfannenmodell").click();
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "changeActiveLink",
      "incrementTrigger",
      "changeActiveContent",
      "postBerechnung"
    ]),
    triggerAll() {
      if (
        document
          .getElementById("collapseHeadWindzone")
          .classList.contains("collapsed")
      ) {
        document.getElementById("collapseHeadWindzone").click();
      }
      if (
        document
          .getElementById("collapseHeadStandort")
          .classList.contains("collapsed")
      ) {
        document.getElementById("collapseHeadStandort").click();
      }

      if (
        document
          .getElementById("collapseHeadGebaeude")
          .classList.contains("collapsed")
      ) {
        document.getElementById("collapseHeadGebaeude").click();
      }

      if (
        document
          .getElementById("collapseHeadDach")
          .classList.contains("collapsed")
      ) {
        document.getElementById("collapseHeadDach").click();
      }
      if (
        document
          .getElementById("collapseHeadPfannenmodell")
          .classList.contains("collapsed")
      ) {
        document.getElementById("collapseHeadPfannenmodell").click();
      }
    },
    makeCalculation() {
      this.triggerAll();

      if (this.isErlaubt) {
        var params = {
          windzone: this.windzone,
          standort: this.standort,
          standorthoehe: this.standorthoehe,
          dachform: this.dachform,
          gebaeudehoehe: this.gebaeudehoehe,
          geschlossen: this.geschlossen,
          deckunterlage: this.deckunterlage,
          lattung: this.lattung,
          dachneigung: this.dachneigung,
          trauflaenge: this.trauflaenge,
          giebellaenge: this.giebellaenge,
          walmtrauflaenge: this.walmtrauflaenge,
          walmneigung: this.walmneigung,
          pfannenmodell: this.pfannenmodell,
          dachpfannenObject: this.dachpfannenObject,
          pfanne: this.dachpfannenObject.id
        };
        var calc = new WindsogCalculator(params);
        var result = calc.calculate();
        this.$store.commit("setCalculationResult", result);

        if (this.$store.state.inputs.calculationResult != null) {
          // Klammertyp anhand Lattung anpassen
          if (this.lattung == "30 x 50 mm") {
            this.dachpfannenObject.klammertyp = this.dachpfannenObject.klammertyp.replace(
              "40x60",
              "30x50"
            );
          } else {
            this.dachpfannenObject.klammertyp = this.dachpfannenObject.klammertyp.replace(
              "30x50",
              "40x60"
            );
          }

          this.changeActiveContent("berechnung");
          this.changeActiveLink("berechnung");
          this.incrementTrigger();
          if (this.$store.state.inputs.calculationResult.Error == false)
            this.postBerechnung(this.calculationResult);
          window.scrollTo(0, 0);
        }
      } else if (!this.isComplete) {
        document.getElementById("incomplete").show();
      }
    }
  },
  created: () => {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
};
</script>


<style>
/********* Lütfrink Collapse *********/

.luetfrink-collapse {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid rgba(71, 71, 71, 0.3);
  transition: background-color ease-in 1s;
}

.luetfrink-collapse:hover {
  box-shadow: 3px 5px 2px rgba(71, 71, 71, 0.05);
  cursor: pointer;
}

.luetfrink-collapse-img {
  width: 20px;
  float: right;
  clear: right;
  transition: all 0.15s ease;
  vertical-align: middle;

  margin-right: 10px;
  margin-top: 10px;
}

/*  Dreht das Collapse Icon um 180 Grad, wenn der collapse auf ist  */
.luetfrink-collapse.collapsed .luetfrink-collapse-img {
  transform: scaleY(-1);
}

.luetfrink-collapse-card {
  padding-left: 0;
  border: none;
}

:target {
  display: block;
  position: relative;
  top: -120px;
  visibility: hidden;
}

.plzInfo {
  font-size: 0.8em;
  font-style: italic;
}

@media (max-width: 991px) {
  .luetfrink-collapse {
    width: 100%;
  }
  :target {
    display: block;
    position: relative;
    top: -45vh;
    visibility: hidden;
  }
}

@media (max-width: 575.98px) {
  .luetfrink-collapse {
    font-size: 1.1em;
    font-weight: 400;
  }
}

.activeCol {
  -webkit-animation-name: blink; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 4s; /* Safari 4.0 - 8.0 */
  animation-name: blink;
  animation-duration: 4s;
}

.activeBtn {
  -webkit-animation-name: flash; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 4s; /* Safari 4.0 - 8.0 */
  animation-name: flash;
  animation-duration: 4s;
}

/********* SETTINGS **************/
.settings {
  padding: 0;
}
@media (max-width: 991px) {
  .settings {
    top: 30vh;
  }
}

/************* ANIMATIONS ******************/
/* The animation code blink animation*/
@keyframes blink {
  50% {
    background-color: #dbedfb;
  }
  100% {
    background-color: #fff;
  }
}

/* The animation code for flash animation*/
@keyframes flash {
  25% {
    background-color: #0098ff;
    border-color: #0098ff;
  }
  50% {
    background-color: #006fba;
    border-color: #006fba;
  }
  75% {
    background-color: #0098ff;
    border-color: #0098ff;
  }
  100% {
    background-color: #006fba;
    border-color: #006fba;
  }
}
</style>
